import React, {
    useContext,
    useEffect,
    useState,
    useCallback,
    createContext,
} from "react";
import { useAuth } from "hooks/Auth";
import { apiGet } from "helpers/Request";
import { transform as channelTransformer } from "schemas/Channel";
import { getPaginationMeta } from "schemas/Util";
import MainBlock from "components/DesignSystem/LayoutBlocks/MainBlock";
import { useLocation } from "react-router-dom";
import Pagination from "components/General/Pagination";
import { AppContext } from "context/App";
import ChannelTable from "./ChannelTable";
import ChannelListToolbar from "./ChannelListToolbar";

export const ChannelListContext = createContext();

export default function ChannelScreen(props) {
    const auth = useAuth();
    const location = useLocation();
    const { setCurrentNav } = useContext(AppContext);

    const [loading, setLoading] = useState(true);
    const [items, setItems] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [paginationMeta, setPaginationMeta] = useState({});
    const [queryParams, setQueryParams] = useState(
        new URLSearchParams(location.search)
    );

    const setSelected = (e, id) => {
        if (e.target.checked) {
            setSelectedItems([...selectedItems, id]);
        } else {
            setSelectedItems(selectedItems.filter((item) => item !== id));
        }
    };

    const load = useCallback(() => {
        setLoading(true);
        setItems([]);
        setSelectedItems([]);
        const defaultParams = {
            per_page: 40,
            dir: "asc",
            order: "title",
            include: ["settings"],
        };
        const definedParams = Object.fromEntries(
            new URLSearchParams(location.search)
        );

        apiGet(
            "/v4/channel",
            auth.publication,
            Object.assign({}, defaultParams, definedParams)
        ).then((res) => {
            setItems(channelTransformer(res));
            setPaginationMeta(getPaginationMeta(res));
            setLoading(false);
        });
    }, [location, auth.publication]);

    useEffect(() => {
        load();
        setQueryParams(new URLSearchParams(location.search));
    }, [location, load]);

    useEffect(() => {
        setCurrentNav("custom-content");
    }, [setCurrentNav]);

    return (
        <MainBlock>
            <ChannelListContext.Provider
                value={{ items, selectedItems, loading, load }}
            >
                <ChannelListToolbar queryParams={queryParams} />
                <ChannelTable
                    addSelected={setSelected}
                    setAllSelected={setSelectedItems}
                    queryParams={queryParams}
                />
            </ChannelListContext.Provider>

            <div className="my-4">
                <Pagination
                    basePath="custom-content/channel"
                    {...paginationMeta}
                />
            </div>
        </MainBlock>
    );
}
